<template>
  <div class="latest-wins-widget">
    <div class="latest-wins-header">
      <div class="live-dot"></div>

      <span>{{ $t('latest_wins') }}</span>
    </div>

    <div v-if="isLoadingLatestWins" class="loading-state">
      <div class="spinner"></div>
    </div>

    <div v-else-if="duplicatedWins.length > 0" class="ticker-window">
      <div class="ticker-track">
        <div
            v-for="(win, index) in duplicatedWins"
            :key="win.betCode + '-' + index"
            class="win-card"
            @click="openBetDetail(win)"
        >
          <div class="card-glow"></div>

          <div class="top-strip">
            <div class="winner-info">
              <div class="winner-name">{{ $t('' + win.category) }}</div>
              <div class="winner-code">#{{ win.betCode }}</div>
            </div>
            <div class="status-badge">
              <v-icon size="14" color="var(--color-primary)">mdi-check-circle</v-icon>
            </div>
          </div>

          <div class="amount-box">
            <span class="amount-label">{{ $t('total_win') }}</span>

            <span class="amount-value">{{ win.currency }}{{ win.amount }}</span>
          </div>

          <div class="bottom-strip">
            <div class="win-time">{{ translateTime(win.time) }}</div>

          </div>
        </div>
      </div>
    </div>

    <!-- === BET DETAIL DIALOG === -->
    <transition name="td-backdrop-fade">
      <div v-if="dialog" class="td-overlay-backdrop" @click.self="dialog = false">
        <transition name="td-sheet">
          <div v-if="dialog && selectedWin" class="td-card" @click.stop>


            <div class="td-topbar">
              <div class="info-item">
                <span class="info-label">{{ $t('user') }}</span>
                <span class="info-val blurred-sensitive">xxxxxxxxx</span>
              </div>
              <div class="info-item">
                <span class="info-label">{{ $t('ticket_id') }}</span>
                <span class="info-val blurred-sensitive">xxxxxxxxx</span>
              </div>
              <div class="td-topbar-right">
                <button class="td-icon-btn" @click="dialog = false">
                  <svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/></svg>
                </button>
              </div>
            </div>



            <!-- Sub-header -->
            <div class="td-subheader">
              <div class="td-subheader-left">
                <span class="td-type">{{ $t('' + selectedWin.category) }}</span>
              </div>
              <span class="td-date">{{ translateTime(selectedWin.time) }}</span>
            </div>

            <!-- Ticket -->
            <div class="td-ticket">
              <div class="td-ticket-head">
                <div class="td-ticket-head-left">
                  <svg viewBox="0 0 24 24" fill="currentColor" width="14" height="14" style="flex-shrink:0"><path d="M20 12c0-1.1.9-2 2-2V6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v4c1.1 0 2 .9 2 2s-.9 2-2 2v4c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-4c-1.1 0-2-.9-2-2z"/></svg>
                  <span>{{ selectedWin.fullBet.odds.length }} {{ $t('bets.events') }}</span>
                </div>
                <span class="td-result-badge td-result-badge--win">{{ $t('bets.win') }}</span>
              </div>

              <div class="td-ticket-body">
                <div v-for="(odd, index) in selectedWin.fullBet.odds" :key="index" class="td-leg">
                  <div class="td-leg-summary">
                    <div class="td-leg-event">
                      <span class="td-leg-event-name">{{ odd.event_description }}</span>
                    </div>
                    <div class="td-leg-result-icon">
                      <svg class="result-svg result-svg--win" viewBox="0 0 20 20" fill="currentColor" width="16" height="16"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"/></svg>
                    </div>
                  </div>
                  <div class="td-leg-detail">
                    <div class="td-leg-market-row">
                      <span class="td-leg-outcome">{{ odd.outcome_name }}</span>
                      <span class="td-leg-odd">{{ Number(odd.outcome_odd_value).toFixed(2) }}</span>
                    </div>
                    <div class="td-leg-market-name">{{ odd.market_name }}<span v-if="odd.specifier"> ({{ odd.specifier }})</span></div>
                  </div>
                </div>

                <div class="td-ticket-divider">
                  <div class="td-ticket-divider-line"></div>
                </div>

                <div class="td-footer">
                  <div class="td-footer-row">
                    <span class="td-footer-label">{{ $t('played_amount') }}</span>
                    <span class="td-footer-value">{{ selectedWin.currency }}{{ selectedWin.fullBet.amount_real.toFixed(2) }}</span>
                  </div>
                  <div class="td-footer-row td-footer-row--winning">
                    <span class="td-footer-label">{{ $t('total_win') }}</span>
                    <span class="td-footer-value td-footer-value--win">{{ selectedWin.currency }}{{ selectedWin.amount }}</span>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </transition>
      </div>
    </transition>

  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'LatestWins',
  data: () => ({ dialog: false, selectedWin: null }),
  computed: {
    ...mapGetters({
      getLatestWins: 'bestPlayed/getLatestWins',
      isLoadingLatestWins: 'bestPlayed/isLoadingLatestWins',
      getPlatformId: 'settings/getPlatformId'
    }),
    duplicatedWins() {
      const wins = this.getLatestWins || []
      return wins.length ? [...wins, ...wins] : []
    }
  },
  mounted() {
    this.fetchLatestWins({ platform_id: this.getPlatformId, limit: 6 })
  },
  methods: {
    ...mapActions({ fetchLatestWins: 'bestPlayed/fetchLatestWins' }),
    translateTime(str) {
      if (!str) return ''
      if (str === 'just_now') return this.$t('just_now')
      const [num, key] = str.split(' ')
      return key ? `${num} ${this.$t('' + key)}` : str
    },
    openBetDetail(win) {
      this.selectedWin = win
      this.dialog = true
    }
  }
}
</script>

<style scoped>
/* ── Widget root ── */
.latest-wins-widget {
  border-radius: var(--radius);
  border: 1px solid var(--border-color);
  overflow: hidden;
  color: var(--text-platform);
  margin-top: 20px;
}

/* ── Header ── */
.latest-wins-header {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 0 6px 14px;
  border-bottom: 1px solid var(--border-color);
  font-weight: 700;
  text-transform: uppercase;
  gap: 6px;
  font-size: var(--font-size-7xl);
  color: var(--text-platform);
  margin-bottom: 2px;

}


.live-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--color-primary);
  box-shadow: 0 0 0 4px var(--color-primary-op);
  animation: pulse 1.8s infinite;
}


/* ── Ticker: scroll continuo via CSS animation ── */
.ticker-window {
  height: 300px;
  overflow: hidden;
  position: relative;
}

/* Fade top/bottom per effetto profondità */
.ticker-window::before,
.ticker-window::after {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  height: 28px;
  z-index: 2;
  pointer-events: none;
}
.ticker-window::before {
  top: 0;
  background: linear-gradient(to bottom, var(--bg-body), transparent);
}
.ticker-window::after {
  bottom: 0;
  background: linear-gradient(to top, var(--bg-body), transparent);
}

.ticker-track {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 8px 0;
  animation: ticker-scroll 18s linear infinite;
}

/* Pausa al hover sul widget — zero JS */
.latest-wins-widget:hover .ticker-track {
  animation-play-state: paused;
}

/* ── Card ── */
/* ── Card (Stile Ticket) ── */
.win-card {
  position: relative;
  flex-shrink: 0;
  border-radius: var(--radius);
  padding: 10px 12px;
  cursor: pointer;
  background: var(--event-background);
  border: 1px solid var(--border-color);
  /* Sostituisco box-shadow con filter nella transizione */
  transition: border-color .2s ease, filter .2s ease;
  overflow: hidden;

  /* Effetto "Buchi" laterali del ticket */
  -webkit-mask-image:
      radial-gradient(circle at 0px calc(100% - 28px), transparent 6px, black 6.5px),
      radial-gradient(circle at 100% calc(100% - 28px), transparent 6px, black 6.5px);
  mask-image:
      radial-gradient(circle at 0px calc(100% - 28px), transparent 6px, black 6.5px),
      radial-gradient(circle at 100% calc(100% - 28px), transparent 6px, black 6.5px);
  -webkit-mask-size: 51% 100%;
  mask-size: 51% 100%;
  -webkit-mask-repeat: no-repeat;
  mask-repeat: no-repeat;
  -webkit-mask-position: left center, right center;
  mask-position: left center, right center;
}

/* Importante: poiché la maschera (mask-image) taglia fisicamente i bordi,
   un box-shadow normale verrebbe nascosto. Usiamo filter: drop-shadow! */
.win-card:hover {
  border-color: var(--color-primary-light-op-50);
  filter: drop-shadow(0 4px 10px var(--color-primary-op));
}

/* Linea tratteggiata per l'effetto strappo, allineata ai buchi laterali */
.win-card::after {
  content: '';
  position: absolute;
  bottom: 28px; /* Si posiziona perfettamente sopra la .bottom-strip */
  left: 10px;
  right: 10px;
  height: 1px;
  border-top: 1.5px dashed var(--border-color);
  opacity: 0.5;
  z-index: 0;
  pointer-events: none; /* Impedisce che blocchi i click sulla card */
}

/* Il tuo glow rimane intatto */
.card-glow {
  position: absolute;
  top: -20px;
  left: -10px;
  width: 70px;
  height: 70px;
  background: radial-gradient(circle, var(--color-primary-op), transparent 70%);
  pointer-events: none;
}

.card-glow {
  position: absolute;
  top: -20px;
  left: -10px;
  width: 70px;
  height: 70px;
  background: radial-gradient(circle, var(--color-primary-op), transparent 70%);
  pointer-events: none;
}

.top-strip,
.bottom-strip {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 6px;
}

.avatar-badge,
.status-badge {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  background: var(--color-primary-op);
  font-size: var(--font-size-3xl);
}

.winner-info {
  flex: 1;
  min-width: 0;
}

.winner-name {
  font-size: var(--font-size-2xl);
  font-weight: 700;
  color: var(--text-platform);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.winner-code {
  font-size: var(--font-size-md);
  color: var(--text-op-50-platform);
  margin-top: 1px;
}

.amount-box {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: baseline;
  justify-content: flex-start;
  margin: 8px 0;
  padding: 6px 0;
  border-radius: 4px;
  gap: 8px;
}

.amount-label {
  font-size: var(--font-size-7xl);
  color: var(--text-platform);
  text-transform: uppercase;
  font-weight: 800;

}

.amount-value {
  font-size: var(--font-size-7xl);
  font-weight: 800;
  color: var(--color-primary-light);
  line-height: 1;
}

.win-time {
  font-size: var(--font-size-md);
  color: var(--text-op-50-platform);
  background: rgba(0, 0, 0, 0.2);
  padding: 2px 10px;
  border-radius: 50px;
}

/* ── Loading ── */
.loading-state {
  padding: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.spinner {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: 2px solid var(--border-color);
  border-top-color: var(--color-primary);
  animation: spin .8s linear infinite;
}





/* ── Keyframes ── */
@keyframes ticker-scroll {
  0%   { transform: translateY(0); }
  100% { transform: translateY(-50%); }
}

@keyframes spin { to { transform: rotate(360deg); } }
@keyframes pulse {
  0%, 100% { box-shadow: 0 0 0 0 var(--color-primary-op); }
  50%       { box-shadow: 0 0 0 6px rgba(5, 149, 114, 0); }
}


/* ── Bet Detail Dialog ── */
.td-overlay-backdrop {
  position: fixed; inset: 0; z-index: 9999;
  background: rgba(0,0,0,0.75);
  display: flex; align-items: center; justify-content: center;
}
.td-card {
  position: relative; width: 480px;
  max-width: calc(100vw - 32px); max-height: 90vh;
  background: #1a1a1a; border-radius: 10px; overflow: hidden;
  display: flex; flex-direction: column;
  box-shadow: 0 24px 64px rgba(0,0,0,0.6);
}
@media (max-width: 600px) {
  .td-overlay-backdrop { align-items: flex-end; }
  .td-card { width: 100%; max-width: 100%; height: 100dvh; max-height: 100dvh; border-radius: 0; }
}
.td-backdrop-fade-enter-active { transition: opacity 0.25s ease; }
.td-backdrop-fade-leave-active { transition: opacity 0.2s ease; }
.td-backdrop-fade-enter, .td-backdrop-fade-leave-to { opacity: 0; }
.td-sheet-enter-active { transition: transform 0.3s cubic-bezier(0.32,0.72,0,1), opacity 0.25s ease; }
.td-sheet-leave-active { transition: transform 0.2s cubic-bezier(0.32,0.72,0,1), opacity 0.2s ease; }
.td-sheet-enter, .td-sheet-leave-to { opacity: 0; transform: scale(0.96) translateY(8px); }
@media (max-width: 600px) {
  .td-sheet-enter, .td-sheet-leave-to { opacity: 1; transform: translateY(100%); }
}

.td-topbar {
  display: flex; align-items: center; gap: 8px; justify-content: space-between;
  padding: 12px 14px 8px;
  border-bottom: 1px solid rgba(255,255,255,0.07); flex-shrink: 0;
}
.info-label{
  color: var(--text-op-50-platform);
  font-size: var(--font-size-xl);
}
.info-val{
  color: var(--text-op-50-platform);
  font-size: var(--font-size-3xl);
  font-weight: 600;
}
.td-icon-btn {
  background: transparent; border: none; color: rgba(255,255,255,0.55);
  cursor: pointer; display: flex; align-items: center; justify-content: center;
  padding: 4px; border-radius: 4px; transition: color 0.15s, background 0.15s;
}
.td-icon-btn:hover { color: #fff; background: rgba(255,255,255,0.08); }
.td-code-block { flex: 1; display: flex; align-items: center; gap: 5px; min-width: 0; }
.td-code { font-family: monospace; font-size: var(--font-size-2xl); color: rgba(255,255,255,0.7); overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.td-topbar-right { display: flex; align-items: center; gap: 4px; flex-shrink: 0; }
.td-subheader {
  display: flex; align-items: center; justify-content: space-between;
  padding: 8px 14px 10px; flex-shrink: 0;
}
.td-subheader-left { display: flex; align-items: center; gap: 6px; }
.td-type { font-size: var(--font-size-3xl); font-weight: 700; text-transform: capitalize; color: rgba(255,255,255,0.9); }
.td-date { font-size: var(--font-size-xl); color: rgba(255,255,255,0.35); white-space: nowrap; flex-shrink: 0; margin-left: 8px; }
.td-ticket {
  margin: 0 12px 12px; border-radius: 8px;
  border: 1px solid rgba(255,255,255,0.08);
  flex: 1; overflow-y: auto; display: flex; flex-direction: column;
}
.td-ticket-head {
  display: flex; align-items: center; justify-content: space-between;
  padding: 10px 14px; background: rgba(255,255,255,0.05);
  border-bottom: 2px dashed rgba(255,255,255,0.1);
  position: relative; flex-shrink: 0;
}
.td-ticket-head::before, .td-ticket-head::after {
  content: ''; position: absolute; bottom: -8px;
  width: 16px; height: 16px; background: #1a1a1a;
  border-radius: 50%; border: 1px solid rgba(255,255,255,0.08);
}
.td-ticket-head::before { left: -8px; }
.td-ticket-head::after { right: -8px; }
.td-ticket-head-left { display: flex; align-items: center; gap: 6px; font-size: var(--font-size-3xl); font-weight: 600; color: rgba(255,255,255,0.8); }
.td-result-badge { font-size: var(--font-size-md); font-weight: 800; text-transform: uppercase; letter-spacing: 0.6px; padding: 3px 10px; border-radius: 4px; color: #000; }
.td-result-badge--win { background: #4caf50; }
.td-ticket-body { padding: 10px 14px; flex: 1; }
.td-leg { background: rgba(255,255,255,0.04); border-radius: 6px; margin-bottom: 6px; overflow: hidden; }
.td-leg-summary { display: flex; align-items: center; justify-content: space-between; padding: 8px 10px; gap: 8px; }
.td-leg-event { display: flex; align-items: center; gap: 5px; min-width: 0; }
.td-leg-event-name { font-size: var(--font-size-2xl); color: rgba(255,255,255,0.85); overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.td-leg-result-icon { display: flex; align-items: center; flex-shrink: 0; }
.td-leg-detail { padding: 6px 10px 8px; border-top: 1px solid rgba(255,255,255,0.06); }
.td-leg-market-row { display: flex; justify-content: space-between; align-items: center; margin-bottom: 2px; }
.td-leg-outcome { font-size: var(--font-size-2xl); font-weight: 700; color: var(--color-primary, #f9a825); }
.td-leg-odd { font-size: var(--font-size-2xl); font-weight: 700; color: rgba(255,255,255,0.8); flex-shrink: 0; }
.td-leg-market-name { font-size: var(--font-size-md); color: rgba(255,255,255,0.35); }
.td-ticket-divider { margin: 12px -14px; position: relative; display: flex; align-items: center; }
.td-ticket-divider::before, .td-ticket-divider::after {
  content: ''; width: 10px; height: 20px; background: #1a1a1a;
  border-radius: 0 10px 10px 0; border: 1px solid rgba(255,255,255,0.08); border-left: none; flex-shrink: 0;
}
.td-ticket-divider::after { border-radius: 10px 0 0 10px; border: 1px solid rgba(255,255,255,0.08); border-right: none; }
.td-ticket-divider-line { flex: 1; border-top: 2px dashed rgba(255,255,255,0.1); }
.td-footer { padding-top: 4px; }
.td-footer-row { display: flex; justify-content: space-between; align-items: center; padding: 4px 0; }
.td-footer-row--winning { border-top: 1px solid rgba(255,255,255,0.07); margin-top: 4px; padding-top: 8px; }
.td-footer-label { font-size: var(--font-size-2xl); color: rgba(255,255,255,0.45); display: flex; align-items: center; }
.td-footer-value { font-size: var(--font-size-2xl); font-weight: 700; color: rgba(255,255,255,0.75); }
.td-footer-value--win { color: #4caf50; font-size: var(--font-size-4xl); }
.result-svg--win { color: #4caf50; }


.blurred-sensitive { filter: blur(4px); user-select: none; }
</style>
